import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

import { fromBillAccountCanRegisterActions } from '@amfam/billing/bill-account-can-register/data-access';
import { BillAccountActions } from '@amfam/billing/billaccount/data-access';

import * as fromRoot from '../../core/store';
import { BillAccountTermsComponent } from '../../terms/bill-account-terms/bill-account-terms.component';

@Injectable()
export class BillAccountTermsGuard {
  constructor(private store: Store<fromRoot.RootState>) {}

  /*
    canDeactivate method takes Component, ActivatedRouteSnapshot,RouterStateSnapshot, nextState: RouterStateSnapshot as parameters.
    nextState gives us future url.
  */
  canDeactivate(
    component: BillAccountTermsComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): any {
    // Clear the list when navigated to rest of the app except registration flow.
    if (nextState.url !== '/billing/register') {
      this.store.dispatch(BillAccountActions.billAccountsLoad());
      this.store.dispatch(fromBillAccountCanRegisterActions.CanRegisterClearAction());
    }

    return true;
  }
}
